var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28694 12C4.28694 7.91891 7.5953 4.61054 11.6764 4.61054C14.9418 4.61054 17.7138 6.72932 18.6904 9.6673C17.2815 9.68197 16.0523 9.17445 14.9565 8.1306C14.5995 7.79047 14.0344 7.80417 13.6942 8.16121C13.3541 8.51824 13.3678 9.0834 13.7248 9.42352C15.4353 11.053 17.4888 11.708 19.8064 11.3643C19.8641 11.365 19.9227 11.3601 19.9817 11.3491C20.2115 11.3062 20.4042 11.1787 20.5338 11.0049C22.1534 9.26791 22.7785 7.1818 22.3838 4.82838C22.3022 4.34207 21.842 4.01394 21.3557 4.09548C20.8692 4.17702 20.5411 4.63738 20.6227 5.1237C20.8317 6.3696 20.679 7.48304 20.1562 8.49087C18.7784 5.16465 15.5013 2.82483 11.6764 2.82483C6.60907 2.82483 2.50122 6.93268 2.50122 12C2.50122 17.0673 6.60907 21.1751 11.6764 21.1751C15.568 21.1751 18.8917 18.7526 20.2258 15.3365C20.4051 14.8772 20.1782 14.3594 19.7188 14.18C19.2595 14.0007 18.7418 14.2276 18.5624 14.6869C17.4868 17.441 14.8081 19.3894 11.6764 19.3894C7.5953 19.3894 4.28694 16.0811 4.28694 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/Retry.1e17d32e.svg";
export { ForwardRef as ReactComponent };